import { Observable, combineLatest } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';

export const waitForSourceData = <T>(sources$: Observable<any>[], data$: Observable<T>): Observable<T> =>
  combineLatest(
    sources$.map((data$) =>
      data$.pipe(
        map((v) => !!v) // Transform each value into a boolean
      )
    )
  ).pipe(
    filter((bools) => bools.every((v) => !!v)), // Only continue if all are truthy
    switchMap(() => data$) // Switch to the provided data$ observable when all observables are truthy
  );

export const combinedIsLoading = (observables: Observable<boolean>[]): Observable<boolean> =>
  combineLatest(observables).pipe(map((loadingStates: boolean[]) => loadingStates.some((isLoading) => isLoading)));

export const combinedIsLoaded = (observables: Observable<boolean>[]): Observable<boolean> =>
  combineLatest(observables).pipe(map((loadingStates: boolean[]) => loadingStates.every((isLoaded) => isLoaded)));
